import { observer } from "mobx-react-lite";
import React, { useContext, useRef, useState } from "react";
import { Context } from "..";
import { IUser } from "../models/IUser";
function UserCard(props: { userActive: IUser }) {
  const { store } = useContext(Context);
  const user = store.user;
  const userActive = props.userActive;
  const [isActivated, setActivated] = useState<boolean>(props.userActive.isActivated);
  const profileUser = useRef<HTMLDivElement>(null);

  const onSubmitHandler = async () => {
    const response = await store.activateUser(userActive.email, isActivated, user);
    const profileUserEl: HTMLElement | null = profileUser.current;

    if (response) {
      const page = document.querySelector(".page-messages")
      const message = document.createElement("div");
      message.classList.add("page-message");
      if (profileUserEl) {
        profileUserEl?.classList.add('profile__user--error');
        setTimeout(() => { message.remove(); profileUserEl?.classList.remove('profile__user--error'); }, 5000)
      }
      message.textContent = "Помилка на сервері";
      page?.appendChild(message);
    } else {
      if (profileUserEl) {
        profileUserEl?.classList.add('profile__user--successful');
        setTimeout(() => { profileUserEl?.classList.remove('profile__user--successful'); }, 5000)
      }
    }
  }


  return (
    <div ref={profileUser} className="profile__user" >
      <p className="profile__item text-left">{userActive.email}</p>
      <p className="profile__item">{userActive.phone}</p>
      <p className="profile__item text-left">{userActive.lastName} {userActive.firstName} {userActive.middleName}</p>
      <p className="profile__item">{userActive.workPlace}</p>
      <p className="profile__item">{userActive.diplomaNumber}</p>
      <p className="profile__item">{isActivated ? "Користувач підтверджений" : "Користувач не підтверджений"}</p>
      <div className="profile__activate">
        <input className="profile__input" type="radio" name="isActivated" id={userActive.id + "activated-true"} onChange={() => { setActivated(true) }} />
        <label className="profile__radio" htmlFor={userActive.id + "activated-true"}>Так</label>
        <input className="profile__input" type="radio" name="isActivated" id={userActive.id + "activated-false"} onChange={() => setActivated(false)} />
        <label className="profile__radio" htmlFor={userActive.id + "activated-false"}>ні</label>
        <button className="profile__save-btn" type="button" onClick={onSubmitHandler}>зберегти</button>
      </div>
    </div>
  );
};

export default observer(UserCard);
